export const classPrefix = 'vjc';